module.exports = __webpack_public_path__ + "static/img/graphs.e600678.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphs.png
// module id = 7XDp
// module chunks = 0